import { Icon } from "leaflet";

const blackIcon = new Icon({
  iconUrl: "/marker-icons/marker-icon-2x-black.png",
  shadowUrl: "/marker-icons/marker-shadow.png",
  iconSize: [25, 41],
  iconAnchor: [12, 41],
  popupAnchor: [1, -34],
  shadowSize: [41, 41]
});

const blueIcon = new Icon({
  iconUrl: "/marker-icons/marker-icon-2x-blue.png",
  shadowUrl: "/marker-icons/marker-shadow.png",
  iconSize: [25, 41],
  iconAnchor: [12, 41],
  popupAnchor: [1, -34],
  shadowSize: [41, 41]
});

const goldIcon = new Icon({
  iconUrl: "/marker-icons/marker-icon-2x-gold.png",
  shadowUrl: "/marker-icons/marker-shadow.png",
  iconSize: [25, 41],
  iconAnchor: [12, 41],
  popupAnchor: [1, -34],
  shadowSize: [41, 41]
});

const greenIcon = new Icon({
  iconUrl: "/marker-icons/marker-icon-2x-green.png",
  shadowUrl: "/marker-icons/marker-shadow.png",
  iconSize: [25, 41],
  iconAnchor: [12, 41],
  popupAnchor: [1, -34],
  shadowSize: [41, 41]
});

const greyIcon = new Icon({
  iconUrl: "/marker-icons/marker-icon-2x-grey.png",
  shadowUrl: "/marker-icons/marker-shadow.png",
  iconSize: [25, 41],
  iconAnchor: [12, 41],
  popupAnchor: [1, -34],
  shadowSize: [41, 41]
});

const orangeIcon = new Icon({
  iconUrl: "/marker-icons/marker-icon-2x-orange.png",
  shadowUrl: "/marker-icons/marker-shadow.png",
  iconSize: [25, 41],
  iconAnchor: [12, 41],
  popupAnchor: [1, -34],
  shadowSize: [41, 41]
});

const redIcon = new Icon({
  iconUrl: "/marker-icons/marker-icon-2x-red.png",
  shadowUrl: "/marker-icons/marker-shadow.png",
  iconSize: [25, 41],
  iconAnchor: [12, 41],
  popupAnchor: [1, -34],
  shadowSize: [41, 41]
});

const violetIcon = new Icon({
  iconUrl: "/marker-icons/marker-icon-2x-violet.png",
  shadowUrl: "/marker-icons/marker-shadow.png",
  iconSize: [25, 41],
  iconAnchor: [12, 41],
  popupAnchor: [1, -34],
  shadowSize: [41, 41]
});

const yellowIcon = new Icon({
  iconUrl: "/marker-icons/marker-icon-2x-yellow.png",
  shadowUrl: "/marker-icons/marker-shadow.png",
  iconSize: [25, 41],
  iconAnchor: [12, 41],
  popupAnchor: [1, -34],
  shadowSize: [41, 41]
});

export { blackIcon, blueIcon, goldIcon, greenIcon, greyIcon, orangeIcon, redIcon, violetIcon, yellowIcon };
